/* eslint-disable manty-rules/exported-types-constants-filename -- Support ModuleForm definitions predates the filename rule; splitting would churn every consumer. */
import {
    BACK_OFFICE,
    BUDGET,
    DECISION,
    HUMAN_RESOURCES,
    PROJECTIONS,
} from 'business/constants';
import type { ModuleT } from 'business/types';
import {
    AI_ASSISTANT,
    CSV_IMPORT,
    ESSENTIAL,
    PHASE_BLOCKS,
    UNIFIED_ORG_CHARTS,
} from 'shared/constants';
import type { ExtraFeatureT } from 'shared/types';

import type { ModuleObjectT } from './types';

type ModuleWithExtraFeaturesT = ModuleObjectT<ModuleT> & {
    extraFeatures: ModuleObjectT<ExtraFeatureT>[];
};

export const MODULES: Record<ModuleT, ModuleWithExtraFeaturesT> = {
    [DECISION]: {
        value: DECISION,
        label: 'modules.decision',
        available: true,
        extraFeatures: [
            {
                value: ESSENTIAL,
                label: 'extraFeatures.essential',
                available: true,
            },
            {
                value: CSV_IMPORT,
                label: 'extraFeatures.csvImport',
                available: true,
            },
            {
                value: UNIFIED_ORG_CHARTS,
                label: 'extraFeatures.unifiedOrgCharts',
                available: true,
            },
            {
                value: AI_ASSISTANT,
                label: 'extraFeatures.aiAssistant',
                available: true,
            },
        ],
    },
    [BUDGET]: {
        value: BUDGET,
        label: 'modules.budget',
        available: true,
        extraFeatures: [
            {
                value: PHASE_BLOCKS,
                label: 'extraFeatures.BudgetFlexyPhaseBlocks',
                available: true,
            },
        ],
    },
    [BACK_OFFICE]: {
        value: BACK_OFFICE,
        label: 'modules.backOffice',
        available: true,
        extraFeatures: [],
    },
    [HUMAN_RESOURCES]: {
        value: HUMAN_RESOURCES,
        label: 'modules.humanResources',
        available: true,
        extraFeatures: [],
    },
    [PROJECTIONS]: {
        value: PROJECTIONS,
        label: 'modules.projections',
        available: true,
        extraFeatures: [],
    },
};

const CITIZEN_RELATION = 'citizen_relation';
export const CSV = 'CSV';
const EXTRACTION_LOGS = 'extraction_logs';
const FINANCE = 'finance';
const HOUSING_POPULATION = 'housing_population';
const HR = 'hr';
const MAD = 'mad';
const MANTY_BUDGET = 'manty_budget';
const MISC = 'misc';
const OPEN_DATA = 'open_data';
const POPULATION = 'population';
const PROJECT_MANAGEMENT = 'project_management';
const TECHNICAL_SERVICES = 'technical_services';
const URBAN_PLANNING = 'urban_planning';
const VIEW = 'VIEW';

export const DECISION_PERIMETER = [
    VIEW,
    CITIZEN_RELATION,
    EXTRACTION_LOGS,
    FINANCE,
    HOUSING_POPULATION,
    HR,
    MAD,
    MANTY_BUDGET,
    MISC,
    POPULATION,
    PROJECT_MANAGEMENT,
    TECHNICAL_SERVICES,
    URBAN_PLANNING,
    CSV,
    OPEN_DATA,
];

export type DecisionPerimeterT =
    | typeof CITIZEN_RELATION
    | typeof CSV
    | typeof EXTRACTION_LOGS
    | typeof FINANCE
    | typeof HOUSING_POPULATION
    | typeof HR
    | typeof MAD
    | typeof MANTY_BUDGET
    | typeof MISC
    | typeof OPEN_DATA
    | typeof POPULATION
    | typeof PROJECT_MANAGEMENT
    | typeof TECHNICAL_SERVICES
    | typeof URBAN_PLANNING
    | typeof VIEW;
